import { render, staticRenderFns } from "./UsuariosclientebinariosQuicktable.vue?vue&type=template&id=30fbb417&"
import script from "./UsuariosclientebinariosQuicktable.vue?vue&type=script&lang=js&"
export * from "./UsuariosclientebinariosQuicktable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports